const _import = require('../import-' + process.env.NODE_ENV)

const resumeRouter = [
  {
    path: '/resume/Index',
    name: 'resumeIndex',
    component: _import('resume/Index'),
    meta: {
      title: '简历投递',
      auth: true
    }
  },
  {
    path: '/resume/step2',
    name: 'resumeStep2',
    component: _import('resume/step2'),
    meta: {
      title: '信息完善',
      auth: true
    }
  }
]
export default resumeRouter



// WEBPACK FOOTER //
// ./src/router/work/resume.js